import { BEIGE_600, GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'

import { AnalyticsEvent } from 'utils/analytics'
import { EditionType } from '../photoStudioTypes'
import { FC } from 'react'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { MUIBadge } from 'components/common/MUIBadge'
import { MUIButton } from 'components/common/MUIButton'
import { SkyStyleOption } from './EnhancePanel.component'
import { SkyStyleSelector } from './SkyStyleSelector.component'
import { externalNavigate } from 'utils/helpers'
import { getPricingUrl } from 'utils/localization'
import i18n from 'translations/i18n'
import { useClientPhotoStudio } from '../ClientPhotoStudio.context'
import { useTranslation } from 'react-i18next'

interface NonSubscriberEnhanceUpsellProps {
  skyStyles: SkyStyleOption[]
}

/**
 * Upsell component for non-subscribers in Photo Studio Enhance Panel.
 * Shows locked badge, title, description, subscribe button, and
 * a before/after slider with sky style previews.
 */
export const NonSubscriberEnhanceUpsell: FC<NonSubscriberEnhanceUpsellProps> = ({ skyStyles }) => {
  const { t } = useTranslation(['photo_studio_editing', 'common'])
  const { logPhotoStudioEvent, imageUrl } = useClientPhotoStudio()

  const handleSubscribeClick = () => {
    logPhotoStudioEvent(AnalyticsEvent.PHOTO_STUDIO_SAAS_UPSELL, { editionType: EditionType.ENHANCE })
    externalNavigate(getPricingUrl(i18n.language))
  }

  return (
    <Box
      sx={{
        backgroundColor: BEIGE_600,
        borderRadius: '.8rem',
        height: 'fit-content',
        margin: '1.6rem',
        overflow: 'hidden',
      }}
    >
      <Stack sx={{ padding: 1.6 }} gap={2.4}>
        <Stack gap={1.2}>
          <MUIBadge size="xs" color="coral" icon={<LockOutlinedIcon fontSize="small" />} label={t('common:Subscribers_only')} sx={{ width: 'fit-content' }} />

          <Stack gap={0.4}>
            <Typography variant="text-sm" fontWeight="600" color={GRAY_900}>
              {t('enhance.non_subscribers_title')}
            </Typography>
            <Typography variant="text-xs" fontWeight="400" color={GRAY_700} marginTop={0.6}>
              {t('enhance.non_subscribers_description')}
            </Typography>
          </Stack>

          <MUIButton sx={{ fontSize: '12px', width: 'fit-content' }} size="sm" onClick={handleSubscribeClick}>
            {t('subscribe_to_bkbn_button')}
          </MUIButton>
        </Stack>

        {/* Sky style previews (locked, read-only) */}
        <SkyStyleSelector skyStyles={skyStyles} selectedStyle={null} onStyleSelect={() => { }} isDisabled />
      </Stack>
    </Box>
  )
}
